/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legalnamerequired2Inputs */

const en_legalnamerequired2 = /** @type {(inputs: Legalnamerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official company name is required`)
};

const de_legalnamerequired2 = /** @type {(inputs: Legalnamerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offizieller Firmenname ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Official company name is required" |
*
* @param {Legalnamerequired2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const legalnamerequired2 = /** @type {((inputs?: Legalnamerequired2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legalnamerequired2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legalnamerequired2(inputs)
	return de_legalnamerequired2(inputs)
});
export { legalnamerequired2 as "legalNameRequired" }